import {Injectable} from '@angular/core';
import {UrlBuilder} from '@rsp/shared/util/url-builder';
import {environment} from '@env/environment';
import {QueryStringParameters} from '@rsp/shared/util/query-string-parameters';


@Injectable()
export class ApiEndpointsService {
  constructor() {
  }

  // TODO Merge methods
  // URL
  public createUrl(action: string): string {
    const urlBuilder: UrlBuilder = new UrlBuilder(environment.baseUrlApi, action);
    return urlBuilder.toString();
  }

  // URL WITH QUERY PARAMS
  public createUrlWithQueryParameters(
    action: string,
    queryStringHandler?:
      (queryStringParameters: QueryStringParameters) => void
  ): string {
    const urlBuilder: UrlBuilder = new UrlBuilder(environment.baseUrlApi, action);
    // Push extra query string params
    if (queryStringHandler) {
      queryStringHandler(urlBuilder.queryString);
    }
    return urlBuilder.toString();
  }
}
